import { render, staticRenderFns } from "./guide.vue?vue&type=template&id=28a6c322&scoped=true&"
import script from "./guide.vue?vue&type=script&lang=js&"
export * from "./guide.vue?vue&type=script&lang=js&"
import style0 from "./guide.vue?vue&type=style&index=0&id=28a6c322&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a6c322",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28a6c322')) {
      api.createRecord('28a6c322', component.options)
    } else {
      api.reload('28a6c322', component.options)
    }
    module.hot.accept("./guide.vue?vue&type=template&id=28a6c322&scoped=true&", function () {
      api.rerender('28a6c322', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/gongdeBox/guide.vue"
export default component.exports